exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AccumulatorDescripton_sub-desc_3DsY {\n  margin-top: 6px;\n}\n", ""]);

// exports
exports.locals = {
	"sub-desc": "AccumulatorDescripton_sub-desc_3DsY"
};